(() => {
  if (window.EvilkoFaq) {
    window.EvilkoFaq.init(document);
    return;
  }

  const normalize = value => String(value || '').normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .toLocaleLowerCase()
    .replace(/['’‘`]/g, '')
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();

  const setup = root => {
    if (root.efFaqReady) return;
    const input = root.querySelector('[data-ef-search]');
    const details = Array.from(root.querySelectorAll('[data-ef-item]'));
    if (!input || !details.length) return;
    root.efFaqReady = true;

    const topics = Array.from(root.querySelectorAll('[data-ef-topic]'));
    const groups = Array.from(root.querySelectorAll('[data-ef-group]'));
    const clear = root.querySelector('[data-ef-clear]');
    const status = root.querySelector('[data-ef-status]');
    const empty = root.querySelector('[data-ef-empty]');
    const items = details.map(element => ({
      element,
      text: normalize(element.textContent),
      topics: (element.dataset.efTopics || '').split(/\s+/).filter(Boolean)
    }));
    let activeTopic = 'all';
    let number;
    try {
      number = new Intl.NumberFormat(document.documentElement.lang || 'en');
    } catch {
      number = new Intl.NumberFormat('en');
    }

    if (status) {
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
    }

    const render = () => {
      const tokens = normalize(input.value).split(/\s+/).filter(Boolean);
      let count = 0;
      items.forEach(item => {
        const matchesTopic = activeTopic === 'all' || item.topics.includes(activeTopic);
        const matchesQuery = tokens.every(token => item.text.includes(token));
        item.element.hidden = !(matchesTopic && matchesQuery);
        if (!item.element.hidden) count += 1;
      });
      groups.forEach(group => {
        group.hidden = !Array.from(group.querySelectorAll('[data-ef-item]')).some(item => !item.hidden);
      });
      topics.forEach(button => {
        const active = button.dataset.efTopic === activeTopic;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('is-active', active);
      });
      const filtered = activeTopic !== 'all' || tokens.length > 0;
      if (clear) clear.hidden = input.value.length === 0;
      if (empty) empty.hidden = count !== 0;
      if (status) {
        const template = count === 1 && status.dataset.templateSingle
          ? status.dataset.templateSingle : status.dataset.templateCount || '__COUNT__';
        const message = template.replace(/__COUNT__/g, number.format(count));
        status.hidden = !filtered;
        if (status.textContent !== message) status.textContent = message;
      }
      root.dataset.efActiveTopic = activeTopic;
      root.classList.toggle('is-filtered', filtered);
    };

    const reset = () => {
      input.value = '';
      activeTopic = 'all';
      render();
    };

    input.addEventListener('input', render);
    input.addEventListener('search', render);
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape' && input.value) {
        event.preventDefault();
        input.value = '';
        render();
      }
    });
    const form = input.closest('form');
    if (form && root.contains(form)) {
      form.addEventListener('submit', event => {
        event.preventDefault();
        render();
      });
    }
    if (clear) clear.addEventListener('click', event => {
      event.preventDefault();
      input.value = '';
      render();
      input.focus({ preventScroll: true });
    });
    topics.forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      activeTopic = button.dataset.efTopic || 'all';
      render();
    }));
    root.querySelectorAll('[data-ef-reset]').forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      reset();
      input.focus({ preventScroll: true });
    }));
    root.addEventListener('shopify:block:select', event => {
      const item = event.target.closest('[data-ef-item]');
      if (item && root.contains(item)) {
        reset();
        item.open = true;
      }
    });

    render();
    root.dataset.efEnhanced = 'true';
    root.querySelectorAll('[data-ef-controls]').forEach(element => { element.hidden = false; });
  };

  const init = scope => {
    if (scope.matches && scope.matches('[data-ef-faq]')) setup(scope);
    scope.querySelectorAll('[data-ef-faq]').forEach(setup);
  };
  window.EvilkoFaq = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
